import DeliveryRequest from './delivery-request/DeliveryRequest.vue'
import DeliveryRequestWrapper from './_DeliveryRequestWrapper.vue'
import SupportOpenLockerModal from './modals/SupportOpenLockerModal.vue'
import axios from 'axios'

const PAGE_SIZE = 10

const BASE_DR_STATUSES = ['brand_new', 'completed', 'service_required', 'not_collected']

export default {
  name: 'SupportDeliveryRequests',
  components: { DeliveryRequest, DeliveryRequestWrapper },
  data: function () {
    return {
      deliveryRequests: [],
      page: 0,
      statusIn: BASE_DR_STATUSES
    }
  },
  mounted() {
    this.fetchDeliveryRequests()
  },
  watch: {
    statusIn: function () {
      this.page = 0
      this.fetchDeliveryRequests()
    }
  },
  methods: {
    fetchDeliveryRequests(page = 0) {
      this.$blockUI()
      axios({
        method: 'get',
        url: `/delivery_requests/list_for_support`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        },
        params: {
          page: page,
          page_size: PAGE_SIZE,
          status_in: this.statusIn
        }
      })
        .then((response) => {
          if (page == 0) {
            this.deliveryRequests = response.data
          } else {
            this.deliveryRequests = [...this.deliveryRequests, ...response.data]
          }
        })
        .catch((error) => {
          this.$errorHumanized(error)
        })
        .finally(() => {
          this.$unblockUI()
        })
    },

    onOpenLocker(data) {
      let { boxId, deliveryId, status } = data
      this.adminOpenBox(boxId, deliveryId, status)
    },

    onStatusChanged(data) {
      console.log('onStatusChanged', data)
      this.statusIn = data
    },

    adminOpenBox(boxId, deliveryId, status) {
      this.$blockUI()
      if (this.$dev) {
        this.$unblockUI()
        this.openSupportOpenLockerModal(boxId, deliveryId, status)
        return
      }

      axios({
        method: 'put',
        url: `/boxes/${boxId}/admin_open`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        }
      })
        .then(() => {
          this.openSupportOpenLockerModal(boxId, deliveryId, status)
        })
        .catch((error) => {
          this.$errorHumanized(null, this.$t('error.unableToOpenLocker'))
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    openSupportOpenLockerModal(boxId = '', deliveryId, status) {
      this.$store.commit('modal/open', {
        cmp: SupportOpenLockerModal,
        size: 'full',
        data: { boxId, deliveryId, status },
        callback: () => this.fetchDeliveryRequests()
      })
    },
    loadMoreDrs() {
      this.page = this.page + 1
      this.fetchDeliveryRequests(this.page)
    }
  }
}
